import { Link, useLocation } from "react-router-dom";

const LINKS = [
  { slug: "about", label: "About Us" },
  { slug: "contact", label: "Contact Us" },
  { slug: "privacy", label: "Privacy Policy" },
  { slug: "refund", label: "Refund Policy" },
  { slug: "terms", label: "Terms & Conditions" },
];

/** Site-wide footer with legal + informational page links. Hidden on admin routes so it
 *  doesn't get in the way of the admin dashboard's own layout. */
export function Footer() {
  const { pathname } = useLocation();
  // Admin routes have their own layout — no footer needed there.
  // Landing page (`/`) renders its own dark-themed footer inline, so we skip the global
  // one there to avoid a duplicate/stacked footer.
  if (pathname.startsWith("/admin")) return null;
  if (pathname === "/") return null;
  const year = new Date().getFullYear();
  return (
    <footer
      className="mt-16 border-t border-border bg-elevated/30 px-4 py-8 text-xs text-muted"
      data-testid="site-footer"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap gap-x-5 gap-y-2">
          {LINKS.map((l) => (
            <Link
              key={l.slug}
              to={`/page/${l.slug}`}
              data-testid={`footer-link-${l.slug}`}
              className="transition-colors hover:text-gold"
            >
              {l.label}
            </Link>
          ))}
        </div>
        <div className="text-[11px] text-muted">
          © {year} The Money Gurukul. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
